import { Zusammenfassung } from '@/domain/mitarbeiter/features/anlageassistent/content/Zusammenfassung';
import { AnlageassistentContextType } from '@/domain/mitarbeiter/features/anlageassistent/types/types';
import { faListUl, faUser } from '@fortawesome/pro-regular-svg-icons';
import { TFunction } from 'i18next/typescript/t';
import z, { ZodSchema } from 'zod';

export function createSubStep<TSchema extends ZodSchema>(subStepConfig: {
  title: string;
  schema: TSchema;
  data: z.infer<TSchema>;
  content: React.ReactNode;
}) {
  return subStepConfig;
}

export function createContextConfig({
  t,
}: {
  t: TFunction<'translation', undefined>;
}): AnlageassistentContextType['state'] {
  return {
    currentStepIndex: 0,

    currentSubStepIndex: 0,
    steps: [
      {
        type: 'step',
        title: t('domain.mitarbeiter.create.steps.person.title'),
        icon: faUser,

        subSteps: [
          createSubStep({
            title: t('domain.mitarbeiter.create.steps.person.persoenliches'),
            schema: z.object({ test: z.string() }),
            data: {
              test: '',
            },
            content: <div>Persönliches Content</div>,
          }),
          createSubStep({
            title: t('domain.mitarbeiter.create.steps.person.kontakt'),
            schema: z.object({ test: z.string() }),
            data: {
              test: '',
            },
            content: <div>Kontakt Content</div>,
          }),
          createSubStep({
            title: t('domain.mitarbeiter.create.steps.person.arbeitsbereiche'),
            schema: z.object({ test: z.string() }),
            data: {
              test: '',
            },
            content: <div>Arbeitsbereiche Content</div>,
          }),
        ],
      },

      {
        type: 'summary',
        title: t('domain.mitarbeiter.create.steps.zusammenfassung'),
        icon: faListUl,
        content: <Zusammenfassung />,
      },
    ],
  };
}
